<button
  type="button"
  class="inline-flex items-center whitespace-nowrap rounded-full px-4 py-2 font-semibold border transition-all duration-200 relative"
  [class]="active()
    ? activeClasses()
    : 'bg-neutral-4 border-neutral-1 text-slate-500 hover:bg-white hover:border-neutral-0'"
  (click)="select.emit()"
>
  {{ label() }} ({{ count() }})
  @if (hasUnseen()) {
    <span class="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full ring-2 ring-neutral-3"></span>
  }
</button>
